// src/shared/components/dashboard/index.ts
// ────────────────────────────────────────────────────────────────────────────
// Barrel export — shared dashboard atomic presenters.
// ────────────────────────────────────────────────────────────────────────────
export { default as KpiCell } from './KpiCell';
export type { KpiCellProps } from './KpiCell';

export { default as MiniBar } from './MiniBar';
export type { MiniBarProps, MiniBarItem } from './MiniBar';

export { default as StatusIndicator } from './StatusIndicator';
export type { StatusIndicatorProps } from './StatusIndicator';

export { default as CollapsibleSection } from './CollapsibleSection';
export type { CollapsibleSectionProps } from './CollapsibleSection';

// ── Common format helpers (domain-agnostic) ──────────────────────────────

export function humanBytes(b: number): string {
  if (!b || b === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(b) / Math.log(1024));
  return `${(b / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
}

export function fmtNum(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toLocaleString();
}

export function fmtDate(s: string): string {
  if (!s) return '—';
  try {
    const d = new Date(s);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  } catch { return s; }
}

export function fmtTimestamp(s: string): string {
  if (!s) return '—';
  try {
    const d = new Date(s);
    return d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch { return s; }
}
